import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetCinemas(payload) {
    return Api().get(`/${API_VERSION}/webapp/cinemas`);
  },
  GetCinema(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/cinemas/${payload.cinema_code}/${payload.date}`
    );
  },
  GetCinemasByCity(payload) {
    let query = "";
    if (payload.search) {
      query += `?search=${payload.search}`;
    }
    return Api().get(`/${API_VERSION}/webapp/cinemas/city/${query}`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/CinemaService.js